<template>
  <div>
    <div class="border-bottom border-secondary font-size-xl mb-2">{{ $t('eGiftCardDetails') }}</div>
    <div v-if="loading" class="d-flex">
      <WCSpinner class="mx-auto align-self-center" size="xl" />
    </div>
    <WCGiftCard v-else :gc="giftCardProfile" />
  </div>
</template>
<script>
import axios from 'axios';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import WCGiftCard from '../components/WCGiftCard/WCGiftCard.vue';

export default {
  name: 'GiftCardDetails',
  components: { WCSpinner, WCGiftCard },
  data() {
    return {
      giftCardProfile: {},
      loading: false,
    };
  },
  created() {
    this.getGC();
  },
  methods: {
    async getGC() {
      try {
        this.loading = true;
        const response = await axios.get(`api/gc/${this.$route.params.id}`);
        this.loading = false;
        this.giftCardProfile = response.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
